<template>
  <report-section 
    title="血氧饱和度统计" 
    class="blood-oxygen-stats-section"
  >
    <template v-slot:content>
      <div class="section-blood-oxygen-table">
        <table class="table">
          <thead>
            <tr class="table-row table-header">
              <td class="table-row-item table-header-item">范围（%）</td>
              <td class="table-row-item table-header-item">时长</td>
              <td class="table-row-item table-header-item">总占比</td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;95</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder95TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder95RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;90</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder90TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder90RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;85</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder85TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder85RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;80</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder80TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder80RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;70</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder70TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder70RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td class="table-row-item table-row-item-bold">&lt;60</td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder60TimeStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.bloodOxygenUnder60RatioStr }}
              </td>
            </tr>
          </thead>
        </table>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  }
};
</script>

<style lang="scss" scoped>
// 专门针对血氧饱和度统计的标题样式
.blood-oxygen-stats-section {
  /deep/ .report-section-title-text {
    color: #000000 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    margin-top: -20px !important;
  }
}

.section-blood-oxygen-table {
  width: 326px;
}

.table {
  border: 1px solid #707070;

  &-row {
    display: flex;
    justify-content: space-evenly;

    :nth-child(1){
        width: 80px;
    }

    :nth-child(2){
        width: 135px;
    }

    :nth-child(3){
        width: 111px;
    }

    &-item {
      color: black;
      font-size: 16px;
      border: 1px solid #707070;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-bold {
        // 数据行第一列样式
      }
    }
  }
}

// 表头样式
.table-header {
  .table-header-item {
    font-weight: bold;
  }
}

// 确保打印时样式也生效
@media print {
  .blood-oxygen-stats-section {
    /deep/ .report-section-title-text {
      color: #000000 !important;
      font-size: 16px !important;
      font-weight: bold !important;
      margin-top: -20px !important;
    }
  }

  .table {
    border: 1px solid #707070;

    &-row {
      display: flex;
      justify-content: space-evenly;

      :nth-child(1){
          width: 80px;
      }

      :nth-child(2){
          width: 135px;
      }

      :nth-child(3){
          width: 111px;
      }

      &-item {
        color: black !important;
        font-size: 16px !important;
        border: 1px solid #707070 !important;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .table-header {
    .table-header-item {
      font-weight: bold !important;
    }
  }
}
</style>